import images from "./images";

const projects = [
{
    id: 1,
    image: images.project1,
    title: "Curtain Dry Cleaning",
    details: {
        date: "March 18, 2024",
        client: "Urban Loft Interiors",
        category: "Dry Cleaning",
        duration: "2 Days",
        location: "Downtown Seattle, WA",
        cost: "Priced per panel and fabric type",
        leadDesigner: "Samantha Woodrow"
    },
    paragraphs: [
        "Our Curtain Dry Cleaning project focused on restoring elegance and freshness to high-end drapery without compromising fabric integrity. The goal was to deep clean delicate curtains while preserving their texture, color, and structure.",
        "Using advanced dry cleaning methods and fabric-specific care, our team removed dust, allergens, and stains from heavy and layered curtains. Each panel was carefully treated, inspected, and professionally finished for a crisp, like-new appearance."
    ],
    gallery: [
        images.project1Gallery1,
        images.project1Gallery2,
        images.project1Gallery3,
        images.project1Gallery4,
        images.project1Gallery5,
        images.project1Gallery6,
    ],
    challenges: [
        "Handling Delicate and Expensive Fabrics",
        "Removing Deep-Set Odors and Stains",
        "Maintaining Original Curtain Shape and Pleats"
    ],
    solutions: [
        "Utilized Fabric-Specific Dry Cleaning Techniques",
        "Used Eco-Friendly, Odor-Removing Solvents",
        "Pressed and Rehung Curtains with Precision Tools"
    ],
    results: [
        "Curtains Restored to Original Freshness and Elegance",
        "Improved Indoor Air Quality for the Client",
        "Client Praised the Attention to Detail and Fabric Care"
    ]
},
{
    id: 2,
    image: images.project2,
    title: "Express Folding",
    details: {
        date: "April 10, 2024",
        client: "Metro Apartment Residents",
        category: "Regular Laundry",
        duration: "Same Day Service",
        location: "Central City, NY",
        cost: "Flat rate per load",
        leadDesigner: "Jordan Blake"
    },
    paragraphs: [
        "Our Express Folding service is designed for busy individuals and families who need perfectly folded laundry delivered quickly. For this project, we partnered with a residential complex to offer seamless laundry pickup, wash, and express fold services to residents.",
        "Utilizing our organized workflow and trained staff, each batch of laundry was neatly folded and packaged within hours of washing. The result was crisp, wrinkle-free clothing returned the same day—ready to wear or store."
    ],
    gallery: [
        images.project2Gallery1,
        images.project2Gallery2,
        images.project2Gallery3,
        images.project2Gallery4,
        images.project2Gallery5,
        images.project2Gallery6,
    ],
    challenges: [
        "Handling High Volume Orders Efficiently",
        "Maintaining Consistent Folding Quality",
        "Ensuring Same-Day Turnaround Time"
    ],
    solutions: [
        "Implemented Batch Processing and Workflow Automation",
        "Trained Team in Uniform Folding Standards",
        "Optimized Delivery Routes for Maximum Efficiency"
    ],
    results: [
        "Achieved 100% On-Time Delivery Across Orders",
        "Received Positive Feedback for Neat, Organized Presentation",
        "Boosted Repeat Customer Requests for Regular Service"
    ]
},
{
    id: 3,
    image: images.project3,
    title: "Tailoring Adjustments",
    details: {
        date: "May 05, 2024",
        client: "City Style Boutique",
        category: "Fabric Alterations",
        duration: "2–5 Business Days",
        location: "Uptown Chicago, IL",
        cost: "Varies based on garment and complexity",
        leadDesigner: "Elena Foster"
    },
    paragraphs: [
        "Tailoring Adjustments were provided for a boutique seeking to offer personalized fitting services for their ready-to-wear collection. Our goal was to ensure every garment matched the unique measurements and preferences of individual customers.",
        "The project covered a variety of garments including dresses, trousers, blazers, and shirts. Each piece was expertly altered with attention to seam alignment, stitching finesse, and fit perfection—offering a boutique-quality experience."
    ],
    gallery: [
        images.project3Gallery1,
        images.project3Gallery2,
        images.project3Gallery3,
        images.project3Gallery4,
        images.project3Gallery5,
        images.project3Gallery6,
    ],
    challenges: [
        "Adapting to a Wide Range of Fabric Types",
        "Maintaining Original Design Integrity",
        "Coordinating Fast Turnarounds During Peak Times"
    ],
    solutions: [
        "Assigned Garments Based on Tailor Specialization",
        "Used High-Precision Tools for Seamless Adjustments",
        "Created a Booking System for Balanced Scheduling"
    ],
    results: [
        "Delivered Over 200 Tailored Garments with High Satisfaction",
        "Improved Boutique’s Customer Loyalty and Return Rate",
        "Enhanced Brand Image Through Precision Tailoring Services"
    ]
},
{
    id: 4,
    image: images.project4,
    title: "Color Separation",
    details: {
        date: "April 12, 2024",
        client: "Everyday Wash & Wear",
        category: "Regular Laundry",
        duration: "Same Day Service Available",
        location: "Midtown Atlanta, GA",
        cost: "Included in standard laundry package",
        leadDesigner: "Marcus Reid"
    },
    paragraphs: [
        "Our Color Separation service is designed to protect garments from color bleeding and fading during the wash cycle. This essential process ensures white and light-colored fabrics maintain their original brightness while dark colors retain their vibrancy.",
        "Utilizing professional-grade sorting and detergent solutions, we handle every batch with care. Our team follows a meticulous pre-wash evaluation to sort by shade, fabric type, and wash requirements—delivering crisp, clean results every time."
    ],
    gallery: [
        images.project4Gallery1,
        images.project4Gallery2,
        images.project4Gallery3,
        images.project4Gallery4,
        images.project4Gallery5,
        images.project4Gallery6,
    ],
    challenges: [
        "Handling Mixed Loads with Time Constraints",
        "Preventing Color Transfer in Bulk Batches",
        "Educating Customers on Best Practices"
    ],
    solutions: [
        "Introduced Advanced Color-Safe Sorting Protocols",
        "Used Specialized Detergents and Cold Water Washes",
        "Provided Tips and Labels for Customer Awareness"
    ],
    results: [
        "Achieved 98% Reduction in Color Transfer Incidents",
        "Enhanced Longevity and Brightness of Customer Garments",
        "Increased Repeat Bookings for Regular Laundry Services"
    ]
},
{
    id: 5,
    image: images.project5,
    title: "Professional Suit",
    details: {
        date: "May 6, 2024",
        client: "Corporate Wardrobe Essentials",
        category: "Dry Cleaning",
        duration: "48 Hours Turnaround",
        location: "Uptown Manhattan, NY",
        cost: "Based on fabric and suit type",
        leadDesigner: "Elaine Preston"
    },
    paragraphs: [
        "Our Professional Suit dry cleaning service ensures your business attire remains pristine, sharp, and ready to impress. We use solvent-based cleaning methods that gently lift stains, remove odors, and maintain the suit's shape and fabric integrity.",
        "Every suit is evaluated for fabric type and stain severity before being individually treated. From delicate wool to fine blends, our experienced staff handles each piece with the utmost care, ensuring a fresh, wrinkle-free finish that reflects professionalism."
    ],
    gallery: [
        images.project5Gallery1,
        images.project5Gallery2,
        images.project5Gallery3,
        images.project5Gallery4,
        images.project5Gallery5,
        images.project5Gallery6,
    ],
    challenges: [
        "Maintaining Fabric Integrity Across Different Suit Materials",
        "Removing Persistent Odors from Heavy Usage",
        "Ensuring Sharp Press Without Fabric Shine"
    ],
    solutions: [
        "Tailored Cleaning Cycles Based on Fabric and Weave",
        "Use of Premium, Eco-Friendly Solvents and Deodorizers",
        "Advanced Pressing Equipment with Steam Finish"
    ],
    results: [
        "Revived and Extended Life of High-End Suits",
        "Consistent Customer Satisfaction and Return Clients",
        "Elevated Presentation Standards for Corporate Professionals"
    ]
},
{
    id: 6,
    image: images.project6,
    title: "Custom Fittings",
    details: {
        date: "April 12, 2024",
        client: "Bespoke Apparel Clients",
        category: "Fabric Alterations",
        duration: "1-2 Weeks",
        location: "Midtown Fashion District, NY",
        cost: "Quoted per garment and complexity",
        leadDesigner: "Olivia Martinez"
    },
    paragraphs: [
        "Our Custom Fittings service provides precise tailoring adjustments to ensure every garment fits perfectly and complements your individual style. We work closely with clients to modify clothes for comfort, appearance, and function.",
        "From hemming and resizing to reshaping collars and sleeves, our expert tailors use meticulous measurements and high-quality sewing techniques to enhance the fit and feel of your favorite garments."
    ],
    gallery: [
        images.project6Gallery1,
        images.project6Gallery2,
        images.project6Gallery3,
        images.project6Gallery4,
        images.project6Gallery5,
        images.project6Gallery6,
    ],
    challenges: [
        "Matching Original Stitching and Fabric Patterns",
        "Ensuring Seamless Adjustments without Bulk",
        "Accommodating Unique Body Shapes and Preferences"
    ],
    solutions: [
        "Use of Specialized Sewing Techniques for Invisible Seams",
        "Careful Fabric Matching and Pattern Alignment",
        "Multiple Fitting Sessions for Perfect Tailoring"
    ],
    results: [
        "Garments Tailored to Individual Body Shapes with Flawless Fit",
        "High Client Satisfaction and Repeat Business",
        "Enhanced Confidence and Comfort in Custom-Adjusted Clothing"
    ]
}

];

export default projects;